import {GroupType, useSettingsStore} from '@store/settings.js';
import {computed} from 'vue';
import {useRoute, useRouter} from 'vue-router'

export function useSettings() {
	const route = useRoute();
	const router = useRouter();
	const settingsStore = useSettingsStore();

	const { groupName } = route.params;
	const {
		selection,
		getCurrentGroup,
		getPageIndex,
		getPageByIndex,
		getMaxActiveIndex,
	} = settingsStore;

	const currentGroup = computed(() => {
		return getCurrentGroup(groupName as GroupType);
	});

	const activeIndex = computed(() => {
		return getPageIndex(currentGroup.value, route.name as string);
	});

	const maxActiveIndex = computed(() => {
		return getMaxActiveIndex(currentGroup.value);
	});

	const goToPage = (index: number) => {
		const nextPage = getPageByIndex(currentGroup.value, index);
		if (!nextPage) {
			return false;
		}
		void router.push({
			name: nextPage.routeName,
			params: { groupName }
		});
	};

	const goToNext = () => {
		currentGroup.value.list[activeIndex.value].complete = true;
		const nextIndex = activeIndex.value + 1;
		goToPage(nextIndex);
	}

	const goToBack = () => {
		router.back();
	};

	const checkCurrentPageAccess = () => {
		if(!currentGroup.value) {
			void router.replace({
				name: "Home",
			});
		}
		if(activeIndex.value > maxActiveIndex.value) {
			void router.replace({
				name: "Settings",
				params: { groupName }
			});
		}

		return false;
	};

	return {
		groupName,
		currentGroup,
		selection,
		activeIndex,
		maxActiveIndex,
		goToPage,
		goToNext,
		goToBack,
		checkCurrentPageAccess
	};
}
